import { render, staticRenderFns } from "./ChildSideDrawerContainer.vue?vue&type=template&id=1828f5be&scoped=true&"
import script from "./ChildSideDrawerContainer.vue?vue&type=script&lang=js&"
export * from "./ChildSideDrawerContainer.vue?vue&type=script&lang=js&"
import style0 from "./ChildSideDrawerContainer.vue?vue&type=style&index=0&id=1828f5be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1828f5be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
